export default str => str.charAt(0).toUpperCase() + str.slice(1)



// WEBPACK FOOTER //
// ./src/utils/helpers.js